module.exports = __webpack_public_path__ + "img/17857_L.f4e43fd6.png";